import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 根据子专案编码查找 gltf 文件路径
export const queryGltfPath: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setGltfPath', { data: '', loading: true });
    const res: string = await $http.post('/v1/design/project/getgltfurl', payload);
    commit('setGltfPath', { data: res });
  } catch (e) {
    commit('setGltfPath', { data: '' });
  }
};

// 查找对应的子专案是否存在 gltf 文件
// 有文件时给文件名，没文件时给 null
export const queryGltfExisted: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setGltfExisted', { data: false, loading: true });
    const res = await $http.post('/v1/design/project/hasgltffile', payload);
    commit('setGltfExisted', { data: !!res });
  } catch (e) {
    commit('setGltfExisted', { data: false });
  }
};

// 获取 gltf 文件上传时需要的验证信息
export const queryGltfPolicy: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setGltfPolicy', { data: null, loading: true });
    const res = await $http.post('/v1/design/project/updategltf', payload);
    commit('setGltfPolicy', { data: res });
    return res;
  } catch (e) {
    commit('setGltfPolicy', { data: null });
    throw e;
  }
};

// 上传完成后，更新 gltf 状态
export const updateGltfStatus: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    await $http.post('/v1/design/project/afteruploadgltf', payload);
  } catch (e) {
    store.commit('common/setToast', { visible: true, text: 'gltf 状态更新失败' });
  }
};

// 清除 gltf 文件
export const clearGltfFile: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/design/project/cleargltf', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 是否开启 gltf 预览
export const switchGltfStatus: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setGltfCanPreview', { ...state.canPreview, loading: true });
    await $http.post('/v1/design/project/updategltfstatus', payload);
    commit('setGltfCanPreview', { data: payload.operate });
  } catch (e) {
    commit('setGltfCanPreview', { ...state.canPreview, loading: false });
  }
};
